/* tslint:disable */
/* eslint-disable */
/**
 * Marketplace Api
 * Marketplace Api description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: develop@taykus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AuthorizeSaleRequest } from '../models';
// @ts-ignore
import { Sale } from '../models';
/**
 * SaleApi - axios parameter creator
 * @export
 */
export const SaleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Authorize the payment of a sale
         * @param {AuthorizeSaleRequest} authorizeSaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeSale: async (authorizeSaleRequest: AuthorizeSaleRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorizeSaleRequest' is not null or undefined
            assertParamExists('authorizeSale', 'authorizeSaleRequest', authorizeSaleRequest)
            const localVarPath = `/api/sale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizeSaleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the payment 3DS data
         * @param {string} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {string} [userAgent] 
         * @param {string} [accept] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeSaleWithAuthorization: async (id: string, requestBody: { [key: string]: string; }, userAgent?: string, accept?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('authorizeSaleWithAuthorization', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('authorizeSaleWithAuthorization', 'requestBody', requestBody)
            const localVarPath = `/api/sale/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userAgent !== undefined && userAgent !== null) {
                localVarHeaderParameter['User-Agent'] = String(userAgent);
            }

            if (accept !== undefined && accept !== null) {
                localVarHeaderParameter['Accept'] = String(accept);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the customer sales
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSaleByCustomer: async (start: number, size: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'start' is not null or undefined
            assertParamExists('findSaleByCustomer', 'start', start)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('findSaleByCustomer', 'size', size)
            const localVarPath = `/api/sale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a sale by id
         * @param {string} id The sale id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSaleById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('findSaleById', 'id', id)
            const localVarPath = `/api/sale/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update sale to be retried
         * @param {string} id The sale id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrySale: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retrySale', 'id', id)
            const localVarPath = `/api/sale/{id}/retry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTAuthentication required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} stripeSignature 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhook: async (stripeSignature: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeSignature' is not null or undefined
            assertParamExists('stripeWebhook', 'stripeSignature', stripeSignature)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('stripeWebhook', 'body', body)
            const localVarPath = `/api/sale/webhook/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stripeSignature !== undefined && stripeSignature !== null) {
                localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SaleApi - functional programming interface
 * @export
 */
export const SaleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SaleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Authorize the payment of a sale
         * @param {AuthorizeSaleRequest} authorizeSaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeSale(authorizeSaleRequest: AuthorizeSaleRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeSale(authorizeSaleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the payment 3DS data
         * @param {string} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {string} [userAgent] 
         * @param {string} [accept] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizeSaleWithAuthorization(id: string, requestBody: { [key: string]: string; }, userAgent?: string, accept?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizeSaleWithAuthorization(id, requestBody, userAgent, accept, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all the customer sales
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findSaleByCustomer(start: number, size: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Sale>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findSaleByCustomer(start, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a sale by id
         * @param {string} id The sale id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findSaleById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findSaleById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update sale to be retried
         * @param {string} id The sale id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retrySale(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retrySale(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} stripeSignature 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripeWebhook(stripeSignature: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Sale>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripeWebhook(stripeSignature, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SaleApi - factory interface
 * @export
 */
export const SaleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SaleApiFp(configuration)
    return {
        /**
         * 
         * @summary Authorize the payment of a sale
         * @param {AuthorizeSaleRequest} authorizeSaleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeSale(authorizeSaleRequest: AuthorizeSaleRequest, options?: any): AxiosPromise<Sale> {
            return localVarFp.authorizeSale(authorizeSaleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the payment 3DS data
         * @param {string} id 
         * @param {{ [key: string]: string; }} requestBody 
         * @param {string} [userAgent] 
         * @param {string} [accept] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizeSaleWithAuthorization(id: string, requestBody: { [key: string]: string; }, userAgent?: string, accept?: string, options?: any): AxiosPromise<Sale> {
            return localVarFp.authorizeSaleWithAuthorization(id, requestBody, userAgent, accept, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the customer sales
         * @param {number} start Zero-based page index
         * @param {number} size The page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSaleByCustomer(start: number, size: number, options?: any): AxiosPromise<Array<Sale>> {
            return localVarFp.findSaleByCustomer(start, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a sale by id
         * @param {string} id The sale id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findSaleById(id: string, options?: any): AxiosPromise<Sale> {
            return localVarFp.findSaleById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update sale to be retried
         * @param {string} id The sale id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retrySale(id: string, options?: any): AxiosPromise<Sale> {
            return localVarFp.retrySale(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} stripeSignature 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhook(stripeSignature: string, body: string, options?: any): AxiosPromise<Sale> {
            return localVarFp.stripeWebhook(stripeSignature, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SaleApi - object-oriented interface
 * @export
 * @class SaleApi
 * @extends {BaseAPI}
 */
export class SaleApi extends BaseAPI {
    /**
     * 
     * @summary Authorize the payment of a sale
     * @param {AuthorizeSaleRequest} authorizeSaleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleApi
     */
    public authorizeSale(authorizeSaleRequest: AuthorizeSaleRequest, options?: AxiosRequestConfig) {
        return SaleApiFp(this.configuration).authorizeSale(authorizeSaleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the payment 3DS data
     * @param {string} id 
     * @param {{ [key: string]: string; }} requestBody 
     * @param {string} [userAgent] 
     * @param {string} [accept] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleApi
     */
    public authorizeSaleWithAuthorization(id: string, requestBody: { [key: string]: string; }, userAgent?: string, accept?: string, options?: AxiosRequestConfig) {
        return SaleApiFp(this.configuration).authorizeSaleWithAuthorization(id, requestBody, userAgent, accept, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the customer sales
     * @param {number} start Zero-based page index
     * @param {number} size The page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleApi
     */
    public findSaleByCustomer(start: number, size: number, options?: AxiosRequestConfig) {
        return SaleApiFp(this.configuration).findSaleByCustomer(start, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a sale by id
     * @param {string} id The sale id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleApi
     */
    public findSaleById(id: string, options?: AxiosRequestConfig) {
        return SaleApiFp(this.configuration).findSaleById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update sale to be retried
     * @param {string} id The sale id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleApi
     */
    public retrySale(id: string, options?: AxiosRequestConfig) {
        return SaleApiFp(this.configuration).retrySale(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} stripeSignature 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaleApi
     */
    public stripeWebhook(stripeSignature: string, body: string, options?: AxiosRequestConfig) {
        return SaleApiFp(this.configuration).stripeWebhook(stripeSignature, body, options).then((request) => request(this.axios, this.basePath));
    }
}
